import { Div } from '../../../../base/components/native/div'
import { Input } from '../../../../base/components/native/input'
import { CENTER } from '../../../../base/helpers/style'

export const AssistantSelectorSubject = () => {

    const base = Div()
    const text = Div('of a')
    const input = Input('bear in a hat')
    base.append(text, input)

    input.on('input', (e: any) => {
        if (!input.getValue()) return
        if (['a', 'e', 'i', 'u', 'o'].includes(input.getValue().toString().toLowerCase()[0])) {
            text.text('of an')
        } else {
            text.text('of a')
        }
        base.emit('input', e)
    })
    text.cssClass({
        marginRight: '10px',
        fontSize: '20px',
        lineHeight: '22px',
    })
    input.cssClass({
        border: 'none',
        fontSize: '20px',
        padding: '10px',
        backgroundColor: '#ececf0',
        borderRadius: '5px',
        height: '37px'
    })
    base.cssClass({
        ...CENTER,
        flexDirection: 'row',
        alignItems: 'center',
        margin: '0 10px',
        display: 'none',
    })

    return Object.assign(base, {
        focus: () => {
            input.el.focus()
        },
        getValue: () => {
            return input.getValue()
        }
    })
}